<template>
  <section id="services" class="py-16 md:py-24 bg-neutral-100">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
      <div class="text-center mb-16">
        <h2 class="text-[clamp(1.5rem,3vw,2.5rem)] font-bold text-neutral-700 mb-4">
          我们的服务
        </h2>
        <p class="text-neutral-500 max-w-2xl mx-auto text-lg">
          我们提供全方位的技术服务，满足客户不同的业务需求
        </p>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        <div class="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 group">
          <div class="relative h-48 overflow-hidden">
            <img :src="require('@/assets/service3.png')" alt="移动应用开发"  class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110">
            <div class="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
            <div class="absolute bottom-4 left-4 right-4">
              <h3 class="text-xl font-bold text-white">移动应用开发</h3>
            </div>
          </div>
          <div class="p-6">
            <p class="text-neutral-500 mb-4">
              我们开发高质量的iOS和Android应用，提供从概念设计到应用商店发布的一站式服务，帮助企业拓展移动市场。
            </p>
            <a href="#contact" class="inline-flex items-center text-primary font-medium hover:text-primary/80 transition-colors duration-200">
              了解更多 <i class="fa fa-arrow-right ml-2"></i>
            </a>
          </div>
        </div>

        <!-- 服务卡片 2 -->
        <div class="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 group">
          <div class="relative h-48 overflow-hidden">
            <img :src="require('@/assets/service2.png')" alt="软件开发"  class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"/>
            <div class="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
            <div class="absolute bottom-4 left-4 right-4">
              <h3 class="text-xl font-bold text-white">软件开发</h3>
            </div>
          </div>
          <div class="p-6">
            <p class="text-neutral-500 mb-4">
              我们提供定制软件开发服务，包括企业应用、管理系统、数据分析工具等，满足企业特定的业务需求。
            </p>
            <a href="#contact" class="inline-flex items-center text-primary font-medium hover:text-primary/80 transition-colors duration-200">
              了解更多 <i class="fa fa-arrow-right ml-2"></i>
            </a>
          </div>
        </div>

        <!-- 服务卡片 3 -->
        <div class="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 group">
          <div class="relative h-48 overflow-hidden">
            <img  :src="require('@/assets/forlaw1.png') " alt="技术咨询"  class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110">
            <div class="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
            <div class="absolute bottom-4 left-4 right-4">
              <h3 class="text-xl font-bold text-white">技术咨询</h3>
            </div>
          </div>
          <div class="p-6">
            <p class="text-neutral-500 mb-4">
              我们提供专业的技术咨询服务，帮助企业评估技术需求、选择合适的技术解决方案，制定技术发展战略。
            </p>
            <a href="#contact" class="inline-flex items-center text-primary font-medium hover:text-primary/80 transition-colors duration-200">
              了解更多 <i class="fa fa-arrow-right ml-2"></i>
            </a>
          </div>
        </div>



        <!-- 服务卡片 6 -->
<!--        <div class="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 group">-->
<!--          <div class="relative h-48 overflow-hidden">-->
<!--            <img  :src="require('@/assets/forlaw1.png') " alt="技术咨询" class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"/>-->
<!--            <div class="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>-->
<!--            <div class="absolute bottom-4 left-4 right-4">-->
<!--              <h3 class="text-xl font-bold text-white">技术咨询</h3>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="p-6">-->
<!--            <p class="text-neutral-500 mb-4">-->
<!--              我们提供专业的技术咨询服务，帮助企业评估技术需求、选择合适的技术解决方案，制定技术发展战略。-->
<!--            </p>-->
<!--            <a href="#contact" class="inline-flex items-center text-primary font-medium hover:text-primary/80 transition-colors duration-200">-->
<!--              了解更多 <i class="fa fa-arrow-right ml-2"></i>-->
<!--            </a>-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'Services'
  }
</script>
